// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-pagination[data-v-1cea0a50]{align-items:center;display:inline-flex;justify-content:space-between;min-height:var(--unit-0600);width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
